var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"echarts",staticClass:"charts",style:({width:'100%',height:_vm.chartsBarData.height}),attrs:{"id":_vm.chartsBarData.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }